import { atom } from "recoil"

const tenantScreeningState = atom({
  key: "tenantScreeningState",
  default: {
    property: null,
    agentEmail: null,
    renterEmails: null,
    screeningOption: null,
    payerType: null,
    link: null,
  },
})

const tenantScreeningStateV2 = atom({
  key: "tenantScreeningStateV2",
  default: {
    property: null,
    agentEmail: null,
    renterEmails: null,
    screeningOption: null,
    payerType: null,
    link: null,
  },
})

export  {tenantScreeningState, tenantScreeningStateV2}


